import React, { useContext, useEffect, useRef } from "react";
import styles from "./StoryDmitry.module.scss";
import stylesText from "../../components/Text/Text.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import Cover from '../../components/Cover';
import Figure from '../../components/Figure';
import StoryDate from '../../components/StoryDate';
import Quote from '../../components/Quote';
import Test from '../../components/Test/Test';
import Invite from '../../components/Invite';
import Conclusion from '../../components/Conclusion';
import MoreStory from '../../components/MoreStory';
import SortCard from '../../components/SortCard';
import StickyFiles from '../../components/StickyFiles';
import FileCard from '../../components/FileCard/FileCard';
import DmitryScheme from '../../components/DmitryScheme';
import DmitryRoad from '../../components/DmitryRoad';
import DmitrySchemeMini from '../../components/DmitrySchemeMini';
const StoryDmitry = () => {
  const path = useContext(PathContext);
  const refContruction = useRef(null);
  const isMobile = useContext(MobileContext);
  const refGrant = useRef(null);
  useEffect(() => {

    window.scrollTo(0, 0);

    const wrap = refContruction.current;
    const grant = refGrant.current;

    let options = {
      threshold: 0,
      rootMargin: '0% 0% 0% 0%'
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.animate);
          observer.unobserve(entry.target);
        }
      })
    }, options);
    observer.observe(wrap);
    observer.observe(grant);

    return () => {
      observer.unobserve(wrap);
      observer.unobserve(grant);
    }
  }, []);

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.cover}>
          <Cover img={'dmirty-img'} name={'Дмитрий Николаев'} position={'Менеджер технического трансфера\nна заводе Р-Фарм в Германии'} text={['Привет! У сотрудников Р-Фарм есть возможность реализовываться не только в России, но и на зарубежных площадках — моя история как раз об этом. А еще — об успехах и неудачах.']}>
            <>

              <div className={styles.constructions} ref={refContruction}>
                <div className={styles.constructions__row}>

                  <div className={`${styles.construct} ${styles.construct_1}`}>

                    <Figure color={"green"}>
                      <div className={styles.construct__text}>три страны за семь лет</div>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_2}`}>

                    <Figure bg={"transparent-hex.svg"} form={'circle'}>
                    </Figure>
                  </div>
                </div>

                <div className={styles.constructions__row}>
                  <div className={`${styles.construct} ${styles.construct_3}`}>
                    <Figure color={"pink"}>
                      <div className={styles.construct__text}>Китай</div>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_4}`}>
                    <Figure bg={"green-triangle.svg"} form={'circle'}>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_5}`}>
                    <Figure bg={'transparent-saw-dmitry.svg'}>
                      <div className={styles.construct__text}>Россия</div>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_6}`}>

                    <Figure color={ "green_light"} form={isMobile ? null : 'rect'}>
                      <div className={styles.construct__text}>Германия</div>
                    </Figure>
                  </div>
                </div>
              </div>
            </>
          </Cover>
        </div>

        <section data-stage='0' className={`${styles.stage} ${styles.stage_1}`}>
          <div className="container">
            <StoryDate date={'2015 год'} title={'Россия: начало'} color={'purple'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_1}`} data-animate={'fade-in-up'}>
              <p>В конце 2015 года я ушел из аспирантуры Сибирского отделения СО РАН. Там я занимался фундаментальной наукой — молекулярной биологией.
              </p>
              <p>
                На тематическом форуме увидел объявление Р-Фарм о поиске сотрудников и решил попробовать. Подготовил резюме и отправил отклик, особо ни на что не надеясь. А через пару недель мне перезвонили.
              </p>
            </div>
            <div className={styles.grant} ref={refGrant}>
              <div className={styles.grant__list}>
                <div className={styles.grant__item}>
                  <div className={styles.grant__img}>
                    <img src={`${path}/img/dmitry-start-1.webp`} alt="" />
                  </div>
                  <div className={`${styles.grant__text} ${styles.grant__text_1}`}>
                    Успешно прошел два раунда интервью
                  </div>
                </div>
                <div className={styles.grant__separator}>
                  <svg width="61" height="10" viewBox="0 0 61 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="4.5" cy="5.47314" r="4.5" fill="#7E97F8" />
                    <circle cx="30.5" cy="5.47314" r="4.5" fill="#7E97F8" />
                    <circle cx="56.5" cy="5.47314" r="4.5" fill="#7E97F8" />
                  </svg>
                </div>
                <div className={styles.grant__item}>
                  <div className={`${styles.grant__img} ${styles.grant__img_2}`}>
                    <img src={`${path}/img/dmitry-start-2.webp`} alt="" />
                  </div>
                  <div className={`${styles.grant__text} ${styles.grant__text_2}`}>
                    Получил предложение о работе и переехал из Новосибирска в Ярославль

                  </div>
                </div>
              </div>
              {/* <a href='https://' className={styles.grant__link}><span>Подробнее о стипендиальной программе</span></a> */}
            </div>
            <div className={`${styles.quote} ${styles.quote_1}`}>
              <Quote text={['Р-Фарм помогает сотрудникам с переездом:', ' от поиска жилья до адаптации в новом городе.', ' Есть программы оплаты жилья, помощи с переездом ', 'супругов, устройством детей в детские сады или', ' школы.']} textMobile={['Р-Фарм помогает', ' сотрудникам с переездом:', ' от поиска жилья ', 'до адаптации в новом городе.', 'Есть программы оплаты', ' жилья, помощи с переездом ', 'супругов, устройством детей', ' в детские сады или школы.']} color={'purple'} />
            </div>

          </div>
        </section>


        <section data-stage='1' className={`${styles.stage} ${styles.stage_2} `}>

          <div className="container">
            <StoryDate date={'2016'} title={'Китай'} color={'purple'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_2}`} data-animate={'fade-in-up'}>
              <p>В мае 2016 года я попал в программу международных стажировок Р‑Фарм и на четыре месяца отправился в Китай, город Сучжоу, провинции Цзянсу. Стажировка проходила в компании «Сучжоу Альфамаб» — она занималась контрактной разработкой некоторых продуктов Р-Фарм.</p>
              <p>Было сложно. Раньше я работал с нуклеиновыми кислотами, а тут нужно было погрузиться в стадии выделения и очистки белковых молекул. А еще языковой барьер.</p>
            </div>
            <div className={styles.sort} data-animate={'fade-in-up'}>
              <SortCard />
            </div>

            <div className={`${styles.quote} ${styles.quote_2}`}>
              <Quote text={['За 4 месяца я выучил 200–300 базовых иероглифов', ' и мог читать вывески на улице, но не более того.', ' Повезло, что в команде был коллега с отличным', 'английским — он стал моим проводником в мире Китая.']} textMobile={['За 4 месяца я выучил 200–300', ' базовых иероглифов и мог', ' читать вывески на улице,', ' но не более того. Повезло, что', ' в команде был коллега', ' из России с отличным', ' английским — он стал моим', ' проводником в мире Китая.']} color={'purple'} />
            </div>
          </div>
        </section>


        <section data-stage='2' className={`${styles.stage} ${styles.stage_3}`}>

          <div className="container">
            <StoryDate date={'2016-2020 годы'} title={'Россия: успехи'} color={'purple'} />


            <div className={`${stylesText.paragraph} ${styles.paragraph_3}`} data-animate={'fade-in-up'}>
              <h3>Возвращение в Ярославль</h3>
              <p>После Китая я вернулся в Ярославль и около года проработал в должности инженера-биотехнолога по направлению очистки. Затем мой руководитель пошел на повышение, а я занял его должность и проработал на ней до конца 2020 года.</p>

              <p>Это был мой первый опыт в роли руководителя. Но было несложно. Я управлял в основном процессами, а не людьми. При этом процессов было много, а людей — всего десять человек.</p>
            </div>

            <div className={`${stylesText.paragraph} ${styles.paragraph_4}`} data-animate={'fade-in-up'}>
              <div className={styles.img}>
                <picture>
                  <img src={`${path}/img/dmitry-illustration-1.webp`} alt="" />
                </picture>
              </div>
              <h3>Коронавирус</h3>
              <p>А в середине 2020 года началась борьба с коронавирусом. Нам пришлось параллельно реализовывать проекты производства вакцин AstraZeneca и «Спутник V». </p>

              <p>Всё очень быстро закрутилось: в Ярославле налаживали производство AstraZeneca, а в Москве появился завод «Спутник Технополис» — один из крупнейших биотехнических комплексов России и Восточной Европы.</p>


            </div>

            <div className={`${styles.quote} ${styles.quote_3}`}>
              <Quote text={['Задача у нас была максимально сложной — в сжатые', ' сроки наладить производство вакцины. При этом', ' очистка вакцины оказалась самой сложной задачей,', ' за которую я когда-либо брался.']} textMobile={['Задача у нас была', ' максимально сложной —', ' в сжатые сроки наладить', ' производство вакцины. При', ' этом очистка вакцины', ' оказалась самой сложной', ' задачей, за которую я когда-', 'либо брался.']} color={'purple'} />
            </div>
            <div className={`${stylesText.paragraph} ${styles.paragraph_5}`} data-animate={'fade-in-up'}>
              <h3>Вызвался помочь коллегам из Москвы</h3>
              <p>До конца 2020 года нам удалось локализовать производство и наработать инженерные серии вакцины Astra Zeneca, а потом я узнал, что у завода «Спутник Технополис» проблема: не получается наладить процесс производства вакцины. И решил помочь коллегам — это было что-то вроде моего личного вызова. Когда приехал, понял, что многих новых сотрудников нужно обучать с нуля.</p>
            </div>

            <div className={styles.sticky}>
              <div className={styles.sticky__label}>Задачи на стажировке</div>
              <StickyFiles>
                <FileCard
                  label={'Обучал сотрудников'}
                  title={'Рассказывал, что такое хроматограф, какие у него узлы, как им пользоваться'}
                  color={'purple'}
                  img={'dmitry-photo-1-1'}
                />
                <FileCard
                  label={'Обучал сотрудников'}
                  title={'Объяснял, какие материалы должны быть под рукой, чтобы не тратить время на их поиск в соседнем помещении'}
                  color={'purple'}
                  img={'dmitry-photo-1-2'}
                />
              </StickyFiles>
            </div>

            <div className={`${stylesText.paragraph} ${styles.paragraph_6}`} data-animate={'fade-in-up'}>
              <h3>Производство вакцины</h3>
              <p>У вакцины «Спутник V» два компонента. С первым компонентом всё шло отлично, а вот со вторым ничего не выходило. Инструкции разработчика вакцины не помогали.</p>
            </div>

            <div className={styles.scheme} data-animate={'fade-in-up'}>
              <DmitryScheme />
            </div>
            <div className={`${styles.quote} ${styles.quote_4}`}>
              <Quote text={['Я думал, что приеду в Москву на пару недель, помогу', ' коллегам и уеду обратно. А в итоге работал здесь', ' четыре месяца.']} textMobile={['Я думал, что приеду в Москву', ' на пару недель, помогу', ' коллегам и уеду обратно.', ' А в итоге работал здесь', ' четыре месяца.']} color={'purple'} />
            </div>
          </div>
        </section>


        <section data-stage='3' className={`${styles.stage} ${styles.stage_4}`}>
          <div className="container">
            <StoryDate date={'2021 год'} title={'Россия: вызов'} color={'purple'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_7}`} data-animate={'fade-in-up'}>
              <p>Мы с коллегами пытались настроить процесс очистки, но ничего не получалось. Проблемы были также с продуктивностью при культивировании. Производство второго компонента в целом сложнее, чем первого — там было немало подводных камней.</p>
            </div>


            <div className={styles.road} data-animate={'fade-in-up'}>
              <DmitryRoad />
            </div>
            <div className={`${styles.quote} ${styles.quote_5}`}>
              <Quote text={['У меня уже был опыт управления, но не такой', ' масштабный, и он был больше связан с процессами,', ' а не людьми. Плюс давление, сжатые сроки, нервная', ' обстановка. В итоге моя команда со стороны', ' выглядела бездельниками, хотя бесконечно пыталась', 'наладить процесс очистки.']} textMobile={['У меня уже был опыт', ' управления, но не такой', ' масштабный, и он был больше ', 'связан с процессами,', ' а не людьми. Плюс давление,', ' сжатые сроки, нервная ', 'обстановка. В итоге моя', ' команда со стороны', ' выглядела бездельниками,', ' хотя бесконечно пыталась', ' наладить процесс очистки.']} color={'purple'} />
            </div>

            <div className={`${stylesText.paragraph} ${styles.paragraph_8}`} data-animate={'fade-in-up'}>
              <h3>Запустили очистку и начали биться за объемы</h3>
              <p>Всё же в сотрудничестве с одним из партнеров нам удалось запустить процесс. Целевой продукт был получен, началась битва за выходы и объемы произведенного продукта.</p>
              <p>Руководство ждало объемов второго компонента, как на заводах в Ярославле и Ростове при производстве первого: от 1000 до 1800 доз с одного литра культуральной жидкости. А получалось лишь около 100 доз. То есть в 10–18 раз меньше. Это хороший результат: мы сделали всё, что могли. Вытащили весь вирус из культуральной жидкости и очистили его. Но доз мало.</p>
              <p>Мне тогда сказали: «Из вас получился не очень хороший руководитель. Вы не даете достаточно обратной связи, не делаете процесс прозрачным для руководства и не даете нужный объем продукта».</p>
            </div>
            <div className={`${styles.test} `}>
              <Test
                question={'Как вы думаете, почему я получил негативную обратную связь?'}
                answers={['Мне не хватило навыков, чтобы правильно презентовать результаты своей работы.', 'Моя команда была слабая и подвела меня.', 'Человек, который это сказал, некомпетентен.']}
                rightAnswer={0}
                resultTitles={['Верно! ', 'Это совсем не так', 'Это совсем не так']}
                resultText={[['К тому моменту мне просто не хватило навыка, чтобы защитить свою работу и команду. В конце июня 2021 года меня попросили покинуть пост руководителя и вернуться обратно в Ярославль. Я покинул пост руководителя, но продолжил работать в Р‑Фарм: помогал с производством вакцины AstraZeneca, выезжал в Ростов на завод, где производили «Спутник V», эта работа казалась мне очень важной, поэтому я не сдался.', 'Наши ответы совпали, был бы рад работать с вами в Р-Фарм! '], ['Мне просто не хватило навыка, чтобы защитить свою работу и команду. В конце июня 2021 года меня попросили покинуть пост руководителя и вернуться обратно в Ярославль. Я покинул пост руководителя, но продолжил работать в Р-Фарм: помогал с производством вакцины AstraZeneca, выезжал в Ростов на завод, где производили «Спутник V», эта работа казалась мне очень важной, поэтому я не сдался.', 'Наши ответы не совпали, но это не страшно — в атмосфере Р‑Фарм всё может измениться. '], ['Команда была сильная и приложила много усилий! К тому моменту мне просто не хватило навыка, чтобы защитить свою работу и команду. В июне 2021 года я покинул пост руководителя, но продолжил работать в Р-Фарм: помогал с производством вакцины AstraZeneca, выезжал в Ростов на завод, где производили «Спутник V», эта работа казалась мне очень важной, поэтому я не сдался.', 'Наши ответы не совпали, но это не страшно — в атмосфере Р‑Фарм всё может измениться. ']]}
                img={'dmitry-test'}
                color={'purple'}
              />
            </div>

            <div className={`${styles.quote} ${styles.quote_6}`}>
              <Quote text={['Если оценивать результаты команды сейчас, спустя', ' несколько лет, становится понятно, что удалось', ' добиться многого: в такие сжатые сроки, под таким', ' давлением, с новым вирусом добиться очистки', ' и наладить производство — это скорее положительный', ' опыт, чем неудача.']} textMobile={['Если оценивать результаты', ' команды сейчас, спустя', ' несколько лет, становится', ' понятно, что удалось', ' добиться многого: в такие', ' сжатые сроки, под таким', ' давлением, с новым вирусом ', 'добиться очистки и наладить', ' производство — это скорее', ' положительный опыт, чем', ' неудача.']} color={'purple'} />
            </div>
          </div>
        </section>
        <section data-stage='4' className={`${styles.stage} ${styles.stage_5}`}>
          <div className="container">
            <StoryDate date={'2022 год'} title={'Германия'} color={'purple'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_9}`} data-animate={'fade-in-up'}>
              <p>В сентябре 2021 года я получил предложение от завода Р‑Фарм в Германии — там тоже формировали биотехнологическое производство и хотели нанять меня, как одного из самых опытных сотрудников.</p>
              <p>Того же хотели и в Ярославле, Ростове, Москве. Я выбрал Германию, но пока оформлял документы, продолжал поддерживать российских коллег.</p>
            </div>
            <div className={`${styles.scheme} ${styles.scheme_2}`} data-animate={'fade-in-up'}>
              <div className={styles.scheme__title}>В Германии я занимаюсь техтрансфером:</div>
              <DmitrySchemeMini />
            </div>

            <div className={`${stylesText.paragraph} ${styles.paragraph_10}`} data-animate={'fade-in-up'}>
              <h3>Адаптация прошла успешно</h3>
              <p>Адаптироваться к Германии несложно — здесь почти все знают английский, да и сама страна располагает. Здесь много мигрантов и есть налаженные процессы интеграции.</p>
              <p>Главное отличие от России — баланс между работой и личным временем. В Германии люди приходят на работу в 8:00 и уходят в 17:00, независимо от объема и срочности задач. Но при этом они любят спланировать свое рабочее время и делают всё заранее. <br /> Из-за этого со стороны может показаться, что немцы не сильно напрягаются. Но на самом деле это результат четкого планирования, благодаря которому и переделывать потом приходится гораздо меньше.</p>
              <div className={styles.img}>
                <picture>
                  <img src={`${path}/img/dmitry-illustration-2.webp`} alt="" />
                </picture>
              </div>
            </div>

            <div className={`${styles.quote} ${styles.quote_7}`}>
              <Quote text={['Сейчас я живу и работаю больше в немецком стиле', ' и чту баланс работы и жизни. Больше полагаюсь', ' на планирование, и это работает: мы уже провели', ' трансфер одного из продуктов и проводим валидацию', ' процесса.']} textMobile={['Сейчас я живу и работаю', ' больше в немецком стиле', ' и чту баланс работы и жизни.', ' Больше полагаюсь', ' на планирование, и это', ' работает: мы уже провели', ' трансфер одного', ' из продуктов и проводим', ' валидацию процесса.']} color={'purple'} />
            </div>
          </div>
        </section>

        <div className={styles.final}>
          <div className="container">
            <div className={styles.conclusion}>
              <Conclusion img={'dmirty-img'} use={'dmitry'} text={['Мне нравится, как сложилась моя карьера: есть результаты, есть что рассказать внукам, есть куда расти и развиваться.', 'И перспективы в Германии тоже есть: здесь подразделение очистки пока в зачаточном состоянии, работы для меня много. Пока не сделаю всё возможное, не вижу смысла куда-то переходить. Но и мосты с Россией не сжигаю.']}>
                <div className={`${styles.conclusion__construct} ${styles.conclusion__construct_1}`}>
                  <Figure color={'purple'} >
                    Дмитрий Николаев
                  </Figure>
                </div>
                <div className={`${styles.conclusion__construct} ${styles.conclusion__construct_2}`}>
                  <Figure bg={"pink-triangle.svg"} form={'circle'}>
                  </Figure>
                </div>
              </Conclusion>
            </div>
            <div className={styles.invite} data-animate={'fade-in-up'}>
              <Invite color={'purple'} title={'Если вы тоже готовы к взлетам'} desc={'и при этом не боитесь падений, любите узнавать новое, изучать другие культуры и переезжать, приходите в Р-Фарм.'} descMobile={'и при этом не боитесь падений, любите узнавать новое, изучать другие культуры и переезжать, приходите в Р-Фарм.'} />
            </div>
            <div className={styles.more}>
              <MoreStory color={'purple'} />
            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export default StoryDmitry;
